import {
    CHANGE_CAPACITY,
    CHANGE_COLOR,
    SET_ATOMIC_ID,
    SET_DEFAULT_STATE,
} from './constants';
import { AdditionalPageOptions } from 'app/interface';
import { ExtractActions } from '@vfde-fe/sails_core';

/**
 * Fire when color is selected
 * @param value
 */
const changeColor = (value: string) => ({
    type: CHANGE_COLOR,
    value,
});

/**
 * Fire when capacity is selected
 * @param value
 */
const changeCapacity = (value: number) => ({
    type: CHANGE_CAPACITY,
    value,
});

/**
 * Set atomic ID
 */
const setAtomicId = (atomicId: number, forceRerender = true) => ({
    type: SET_ATOMIC_ID,
    atomicId,
    forceRerender,
});

/**
 * Set default state
 */
const setDefaultState = (additionalPageOptions: AdditionalPageOptions) => ({
    type: SET_DEFAULT_STATE,
    additionalPageOptions,
});

/**
 * Action Creators Object
 */
export const optionsActionCreators = {
    changeColor,
    changeCapacity,
    setAtomicId,
    setDefaultState,
};

/**
 * Action Dispatchers Object
 */
export const optionsActionDispatchers = {
    changeColor,
    changeCapacity,
    setDefaultState,
};

/**
 * Action Creators
 */
export type OptionsActionCreators = typeof optionsActionCreators;

/**
 * Action Dispatchers
 */
export type OptionsActionDispatchers = typeof optionsActionDispatchers;

/**
 * Union Action Type
 */
export type OptionsAction = ExtractActions<OptionsActionCreators>;
